import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import Parse from 'parse';

Vue.config.productionTip = false;

Parse.initialize("V5BFyO71y34xCaX7LVWy3kAQqr2LxqrPoFGY8Nf9", "MS8CuVxEVbt7jRpyD055cqJzaxTL6q7EHrpp28Z3");
Parse.serverURL = 'https://parseapi.back4app.com/'

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !store.user) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
